/**
 * Permissão de notificações via Web Notifications API.
 * Cobre navegador desktop, Chrome/Android (incl. PWA) e Safari/iOS (com gesto do usuário).
 * Push/remotos ficam para uma fase posterior; aqui só pedimos permissão do sistema.
 */

const STORAGE_PROMPT_DISMISSED = "gio_notifications_prompt_dismissed_v1";

export function getNotificationSupportInfo() {
  if (typeof window === "undefined") {
    return { supported: false, reason: "no-window" };
  }
  if (!("Notification" in window)) {
    return { supported: false, reason: "no-api" };
  }
  if (!window.isSecureContext) {
    return { supported: false, reason: "insecure-context" };
  }
  return { supported: true };
}

export function getNotificationPermission() {
  if (!("Notification" in window)) {
    return "unsupported";
  }
  return Notification.permission;
}

export function isLikelyIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/i.test(ua)) return true;
  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}

export function isStandalonePwa() {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  return window.navigator.standalone === true;
}

export function wasNotificationPromptDismissed() {
  try {
    return localStorage.getItem(STORAGE_PROMPT_DISMISSED) === "1";
  } catch {
    return false;
  }
}

export function dismissNotificationPrompt() {
  try {
    localStorage.setItem(STORAGE_PROMPT_DISMISSED, "1");
  } catch {
    // ignore
  }
}

/**
 * Deve ser chamado a partir de um gesto explícito (clique/toque).
 * No Safari iOS isso é obrigatório para o prompt do sistema aparecer.
 */
export async function requestNotificationPermission() {
  const info = getNotificationSupportInfo();
  if (!info.supported) {
    return { ok: false, state: "unsupported", reason: info.reason };
  }

  try {
    const state = await Notification.requestPermission();
    return { ok: state === "granted", state };
  } catch (e) {
    return {
      ok: false,
      state: Notification.permission,
      reason: e?.message || "request-failed",
    };
  }
}
